class BannerSlider {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.banner-slider__slide'));
    this.dots = Array.from(el.querySelectorAll('.banner-slider__dot'));
    this.prevBtn = el.querySelector('.banner-slider__arrow--prev');
    this.nextBtn = el.querySelector('.banner-slider__arrow--next');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplay = el.dataset.autoplay === 'true' && !this.reducedMotion;
    this.speed = parseInt(el.dataset.speed, 10) || 5000;
    this.index = 0;
    this.timer = null;
    this.swiped = false;

    // Click ek slide ho tab bhi kaam kare, isliye slider check se pehle bind hota hai
    this.bindClick();

    if (this.slides.length <= 1) return;

    this.bindEvents();
    if (this.autoplay) this.start();
  }

  goTo(i) {
    this.slides[this.index].classList.remove('is-active');
    if (this.dots[this.index]) this.dots[this.index].classList.remove('is-active');
    this.index = (i + this.slides.length) % this.slides.length;
    this.slides[this.index].classList.add('is-active');
    if (this.dots[this.index]) this.dots[this.index].classList.add('is-active');
  }

  next() { this.goTo(this.index + 1); }
  prev() { this.goTo(this.index - 1); }

  start() {
    this.stop();
    this.timer = setInterval(() => this.next(), this.speed);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  // Poora banner clickable: CSS par depend nahi karta
  bindClick() {
    this.el.addEventListener('click', (e) => {
      // swipe ke baad aaya click ignore karo
      if (this.swiped) {
        e.preventDefault();
        e.stopPropagation();
        this.swiped = false;
        return;
      }

      // arrows, dots, button ya kisi bhi link par click ho to unhe apna kaam karne do
      if (e.target.closest('a, button')) return;

      const slide = e.target.closest('.banner-slider__slide');
      if (!slide) return;

      const anchor = slide.querySelector('.banner-slider__link');
      const url = anchor ? anchor.getAttribute('href') : slide.dataset.link;
      if (url) window.location.href = url;
    }, true);
  }

  bindEvents() {
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.next();
        if (this.autoplay) this.start();
      });
    }
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.prev();
        if (this.autoplay) this.start();
      });
    }
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
        if (this.autoplay) this.start();
      });
    });

    // Hover par pause (desktop)
    this.el.addEventListener('mouseenter', () => this.stop());
    this.el.addEventListener('mouseleave', () => {
      if (this.autoplay) this.start();
    });

    // Tab background mein ho to autoplay roko
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stop();
      } else if (this.autoplay) {
        this.start();
      }
    });

    // Swipe support
    let startX = 0;
    this.el.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      this.swiped = false;
    }, { passive: true });

    this.el.addEventListener('touchend', (e) => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        this.swiped = true;
        diff > 0 ? this.next() : this.prev();
        if (this.autoplay) this.start();
      }
    }, { passive: true });
  }
}

document.querySelectorAll('.banner-slider').forEach((el) => new BannerSlider(el));